/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ d: NonNullable<unknown> }} Intervention_Plan_Pdf_Planified_AtInputs */



/**
* | output |
* | --- |
* | "Maintenance on {d}" |
*
* @param {Intervention_Plan_Pdf_Planified_AtInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const intervention_plan_pdf_planified_at = /** @type {((inputs: Intervention_Plan_Pdf_Planified_AtInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intervention_Plan_Pdf_Planified_AtInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Maintenance on ${i?.d}`)
	return /** @type {LocalizedString} */ (`Maintenance du ${i?.d}`)
});